<template>
    <b-col
        :align-self="alignSelf"
        :cols="cols"
    >
        <slot />
    </b-col>
</template>

<script>
import { BCol } from 'bootstrap-vue'

export default {
    components: { BCol },
    props: {
        alignSelf: {type: String},
        cols: {type: [Number, String]},
    },
}
</script>